var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ke-fu",staticStyle:{"padding":"0 15px"}},[_c('span',{staticClass:"icon font_family icon-zaixiankefu",staticStyle:{"font-size":"28px","margin-right":"5px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-41326e65","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/KeFu/index.vue
// module id = 1266
// module chunks = 72